import { render, staticRenderFns } from "./CorpId.vue?vue&type=template&id=2a93ba2c&scoped=true&"
import script from "./CorpId.vue?vue&type=script&lang=js&"
export * from "./CorpId.vue?vue&type=script&lang=js&"
import style0 from "./CorpId.vue?vue&type=style&index=0&id=2a93ba2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a93ba2c",
  null
  
)

export default component.exports